// Tipos aceitos pelo PNCP:
//     pdf, txt, rtf, doc, docx, xls, xlsx, odt, ods, sxw, zip, 7z, rar, dwg, [dwt], dxf, dwf,
//     [dwfx], svg, [sldprt], [sldasm], [dgn], ifc, skp, [3ds], dae, obj, [rfa] e [rte]
export default{
    txt: {extensao:'txt', valor: 'text/plain'},
    pdf: {extensao:'pdf', valor: 'application/pdf'},
    rtf: {extensao:'rtf', valor: 'application/rtf'},
    xls: {extensao: 'xls', valor: 'application/vnd.ms-excel'},
    doc: {extensao: 'doc', valor: 'application/msword'},
    xlsx: {extensao: 'xlsx', valor: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
    docx: {extensao: 'docx', valor: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'},
    odt: {extensao: 'odt', valor: 'application/vnd.oasis.opendocument.text'},
    ods: {extensao: 'ods', valor: 'application/vnd.oasis.opendocument.spreadsheet'},
    sxw: {extensao: 'sxw', valor: 'application/vnd.sun.xml.writer'},
    zip: {extensao:'zip', valor: 'application/zip'},
    x7zip: {extensao:'7zip', valor: 'application/x-7z-compressed'},
    rar: {extensao:'rar', valor: 'application/vnd.rar'},
    skp: {extensao: 'skp', valor: 'application/vnd.koan'},
    ifc: {extensao: 'ifc', valor: 'application/p21'},
    svg: {extensao: 'svg', valor: 'image/svg+xml'},
    dwg: {extensao: 'dwg', valor: 'image/vnd.dwg'},
    dxf: {extensao: 'dxf', valor: 'image/vnd.dxf'},
    dwf: {extensao: 'dwf', valor: 'model/vnd.dwf'},
    dae: {extensao: 'dae', valor: 'model/vnd.collada+xml'},
    obj: {extensao: 'obj', valor: 'model/obj'},
    jpg: {extensao: 'jpg', valor: 'image/jpg'},
    jpeg: {extensao: 'jpeg', valor: 'image/jpeg'},
    png: {extensao: 'png', valor: 'image/png'},
    webp: {extensao: 'webp', valor: 'image/webp'},
    bmp: {extensao: 'bmp', valor: 'image/bmp'},
    pjpg: {extensao: 'pjpg', valor: 'image/pjpg'},
    tif: {extensao: 'tif', valor: 'image/tif'},
    tiff: {extensao: 'tiff', valor: 'image/tiff'}

}
